import { render, staticRenderFns } from "./AccountTransactionLabel.vue?vue&type=template&id=d0c53044&"
import script from "./AccountTransactionLabel.vue?vue&type=script&lang=js&"
export * from "./AccountTransactionLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports